<template>
  <div class="modal fade" ref="alert" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body text-center" style="font-size: 22px">
          {{ alertText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { computed, onMounted, watch } from "@vue/runtime-core";
import { Modal } from "bootstrap";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore();
    const alert = ref();
    const isShow = computed(() => store.getters["commonAlert/get_isShow"]);
    const alertText = computed(() => store.getters["commonAlert/get_text"]);

    //alert的控制器
    let controller;
    onMounted(() => {
      controller = new Modal(alert.value, {});
    });

    // watch 是否開啟alert
    watch(
      isShow,
      (newValue) => {
        if (newValue == true) {
          controller.show(); //alert開啟
        } else {
          controller.hide(); //alert關閉
        }
      },
      { deep: true }
    );

    return {
      alert,
      alertText,
    };
  },
};
</script>

<style></style>
